import { isDefined } from "@omni/utils/helper.utils";
import { RefObject, useEffect } from "react";

import {
    Translate,
    useGranite
} from "@/redux/modules/value/translations/translations.provider";
import { GetStoreStrategy } from "@/services/store.service";
import { DamImage } from "@/utils/dam.utils";
import { useStoreCode } from "@/utils/hooks/store/useStoreCode.hook";
import { useWoosmapServices } from "@/utils/hooks/useWoosmapServices.hook";

import { TooltipTemplate } from "../components/map/tooltip.template";
import { findStoreById } from "../queries/findStoreById.query";
import { MARKER_OFFSET } from "../storeSearch.config";
import { findStoreUrl } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";
import { useMap } from "./useMap.hook";

const renderMarker =
    (storeUrls: StoreUrl[], map: woosmap.map.Map, t: Translate) =>
    (favoriteStore?: woosmap.map.stores.StoreResponse) => {
        if (!isDefined(favoriteStore)) return;

        const marker = new woosmap.map.Marker({
            position: {
                lat: favoriteStore.geometry.coordinates[1],
                lng: favoriteStore.geometry.coordinates[0]
            },
            icon: DamImage.icon.maps.markerFav
        });
        marker.setMap(map);
        const infoWindow = new woosmap.map.InfoWindow({});

        infoWindow.setOffset(new woosmap.map.Point(0, MARKER_OFFSET));
        infoWindow.setContent(
            TooltipTemplate(
                t,
                favoriteStore.properties,
                findStoreUrl(
                    storeUrls,
                    favoriteStore.properties.user_properties.storeId
                )
            )
        );
        marker.addListener("click", () => {
            if (map) {
                infoWindow.open(map, marker.getPosition());
            }
        });
    };

export const usePreferredStoreMarker = (
    mapElementRef: RefObject<HTMLDivElement | null>,
    storeUrls: StoreUrl[]
) => {
    const { StoresService } = useWoosmapServices();

    const storeCode = useStoreCode({ strategy: GetStoreStrategy.Customer });

    const map = useMap(mapElementRef);

    const { t } = useGranite();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!isDefined(StoresService)) return;
        if (!isDefined(map) || !isDefined(storeCode)) return;

        findStoreById(StoresService, storeCode).then(
            renderMarker(storeUrls, map, t)
        );
    }, [storeCode, map]);
};
